import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Container, Row, Col, Form, Table, Modal, Spinner } from 'react-bootstrap';
import { Auth, LoadingComponent } from 'recupero-comunes';
import CoberturaPoliza from './cobertura-poliza';
import { actualizarProvisiones, getCasoImplicado, getParametros, actualizarIndemnizacion, getPretensionesVigentesImplicado } from '../../../../api/api-gestion-defensa';
import { formato_rut, getBase64, today, minDate, moneyPunto, formatoMonto, resetFormatoMontoSinPunto, resetFormatoMonto } from '../../../../common/Formatos';
import { useFormik } from 'formik';
import { obtenerHistorialProvisiones, obtenerProvisionesImplicados } from '../../../../store/actions/gestion-defensa-action';
import { validationSchemasProvision } from '../../../../common/validations-Schemas-provision';
import { esArchivoGrande, subirArchivoGrandeS3 } from '../../../../common/uploadArchivoGranTamano';
import { serviceObtieneParametro } from '../../../../api/api-parametros';
import Mensajes from '../../../mensajes';
import GrillaPrevisionesImplicados from './grillaPrevisionesImplicados';
import { MdComment } from 'react-icons/md';

const Previsiones = ({ handleClose, setShowImplicados, setShowImplicadosHistorial, action, inprocess, implSeleccionado }) => {
    const dispatch = useDispatch();
    const fileRef = useRef();
    const { codMonedaLocal, codMonedaConsolida } = Auth.currentUser();
    const data_gestion_defensa = useSelector((state) => state.gestionDefensaReducer);
    const { llaves, cfg_form39, comboMonedas, comboInstanciasPrevisiones, listaProvisionesVigentes, comboResponsabilidadAsegurado, amparosCia, datosGestionImplicado } = data_gestion_defensa;

    const [loading, setLoading] = useState(false);
    const [key, setKey] = useState('');
    const [involucrado, setInvolucrado] = useState({});
    const [stateMoneda, setStateMoneda] = useState("");
    const [stateFechaActualizacion, setStateFechaActualizacion] = useState(today());
    const [stateComentario, setStateComentario] = useState("");
    const [stateInstanciaProvision, setStateInstanciaProvision] = useState("");
    const [stateMontoTotal, setStateMontoTotal] = useState(0);
    const [responseData, setResponseData] = useState({});
    const [showToast, setShowToast] = useState(false);
    const [parametro, setParametro] = useState("");
    const [fechaActualizaPrevision, setFechaActualizaPrevision] = useState("");
    const [fechaSiniestro, setFechaSiniestro] = useState("");
    const [dataSubmit, setDataSubmit] = useState({});
    const [showConfirm, setShowConfirm] = useState(false);
    const [showModalTotal, setShowModalTotal] = useState(false);
    const [monedaSelected, setMonedaSelected] = useState("");
    const [comentarioVisado, setComentarioVisado] = useState("");
    const [coberturas, setCoberturas] = useState([]);
    const [amparosAfectados, setAmparosAfectados] = useState([]);

    const [stateResponsabilidadAsegurado, setStateResponsabilidadAsegurado] = useState("");
    const [stateAmparoAfectado, setStateAmparoAfectado] = useState("");
    const [responsabilidadAseguradoActual, setResponsabilidadAseguradoActual] = useState("");

    const [showModalProvisionesImplicado, setShowModalProvisionesImplicado] = useState(false);

    const [dataReady, setDataReady] = useState(false);

    const [showConfirmGrande, setShowConfirmGrande] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const [limites, setLimites] = useState({ liviano: 8 * 1000000, pesado: 20 * 1000000 });
    const archivoSubidoRef = useRef({ file: null, s3Bucket: null, s3Key: null });

    // Detección de cambios para habilitar botón (solo PEC)
    const [tieneInformeAnterior, setTieneInformeAnterior] = useState(false);
    const [initialMontos, setInitialMontos] = useState({});
    const [initialRespAseg, setInitialRespAseg] = useState('');

    // Modal obs CIA
    const [showObsCiaModal, setShowObsCiaModal] = useState(false);
    const [obsCiaModalContent, setObsCiaModalContent] = useState('');

    const isPEC = action !== 'button';

    useEffect(() => {
        if (inprocess) handleVerHistorialPretensiones();
    }, []);

    useEffect(() => {
        setMonedaSelected(comboMonedas && comboMonedas?.filter(m => Number(m.id) === Number(stateMoneda))[0]?.nombreCorto);
    }, [comboMonedas, stateMoneda]);

    useEffect(() => {
        if (!inprocess && listaProvisionesVigentes) {
            setDataReady(false);
            const cobs = listaProvisionesVigentes?.listaPretensionesVigentes?.coberturasPoliza.map(pre => ({
                id: pre.id,
                nombre: pre.cobertura,
                codigoCobertura: pre.codigoCobertura,
                codigoAmparoPadre: pre.codigoAmparoPadre,
                montoPretencion: validateMontoMoneda(pre.montoPretencion, 'format'),
                glosaEstado: pre.glosaEstado,
                fechaRegistroFmt: pre.fechaRegistroFmt,
                usuario: pre.usuario,
                actualizaMonto: pre.actualizaMonto,
                montoCobertura: pre.montoCobertura,
                tipoMov: pre.tipoMov,
                totalizaGrpAmparo: pre.totalizaGrpAmparo,
                obsResponsable: pre.obsResponsable || '',
                obsAnalistaCIA: pre.obsAnalistaCIA || '',
            }));
            setCoberturas(cobs);

            // Guardar montos iniciales para detección de cambios
            const initMontos = {};
            cobs.forEach(c => { initMontos[c.id] = Number(validateMontoMoneda(c.montoPretencion, 'reset_format')); });
            setInitialMontos(initMontos);

            let tipoMovimiento = action === "button" ? 261002 : 261003;
            setAmparosAfectados(amparosCia?.amparosCia?.coberturasPoliza?.filter(c => c.totalizaGrpAmparo == tipoMovimiento).map(c => ({ id: c.codigoCobertura, nombre: c.cobertura })));

            const total = cobs.reduce((acc, c) => acc + Number(validateMontoMoneda(c.montoPretencion, 'reset_format')), 0);
            setStateMontoTotal(validateMontoMoneda(total, 'format'));

            const obtenerCasoImplicado = async () => {
                let query = Buffer.from(JSON.stringify({ idCaso: llaves?.['idCaso'], idImplicado: llaves?.['idImplicado'] })).toString('base64');
                const response = await getCasoImplicado(query);
                const result = (action === "button") ? response[0]?.ultimaProvision : response[0]?.ultimaPropuestaIndeminizacion;

                setTieneInformeAnterior(!!result);

                setStateMoneda(response && result?.CodMonedaIngreso ? result?.CodMonedaIngreso : codMonedaLocal);
                setStateComentario(response && result?.Comentario ? result?.Comentario : "");
                setStateInstanciaProvision(response && result?.CodInstancia ? result?.CodInstancia : "");
                setFechaActualizaPrevision(response && result?.FechaActualizacion);
                setFechaSiniestro(response && response[0]?.FechaSiniestro);
                setComentarioVisado(result?.ComentarioVisado || "");
                setStateResponsabilidadAsegurado(response && response[0]?.GradoRespAsegurado || "");
                setInitialRespAseg(String(response?.[0]?.GradoRespAsegurado ?? ""));
                setStateAmparoAfectado(result?.AmparoAfectadoCIA || "");
                setResponsabilidadAseguradoActual(response && response[0]?.GlosaGradoRespAsegurado ? response[0]?.GlosaGradoRespAsegurado : "");

                setInvolucrado({
                    id: response[0]?.IdImplicado,
                    rut: response[0]?.RutInvolucrado,
                    nombre: response[0]?.NombreInvolucrado,
                    tipo: response[0]?.GlosaTipoInvolucrado,
                    patente: response[0]?.Patente,
                    lesionado: response[0]?.GlosaImplLesionado
                });
            };

            const obtenerParametros = async () => {
                let query = Buffer.from(JSON.stringify({ rutcia: 0, parametro: 35 })).toString('base64');
                const response = await getParametros(query);
                setParametro(response.valorParametro);
            };

            const obtenerObsFallback = async () => {
                if (!isPEC || !cobs.some(c => !c.obsResponsable)) return;
                const tipoGestion = datosGestionImplicado?.datosGestionImplicado?.[0]?.codTipoGestion;
                const q = Buffer.from(JSON.stringify({
                    idCaso: llaves?.['idCaso'],
                    idImplicado: llaves?.['idImplicado'],
                    tipoGestion,
                    tipoMovimiento: 261001,
                    situacion: '245002'
                })).toString('base64');
                const resp = await getPretensionesVigentesImplicado(q);
                const pretCobs = resp?.listaPretensionesVigentes?.coberturasPoliza || [];
                if (pretCobs.length > 0) {
                    setCoberturas(prev => prev.map(c => ({
                        ...c,
                        obsResponsable: c.obsResponsable || pretCobs.find(p => p.codigoCobertura === c.codigoCobertura)?.obsResponsable || ''
                    })));
                }
            };

            const obtenerLimites = async () => {
                const [liviano, pesado] = await Promise.all([serviceObtieneParametro(52), serviceObtieneParametro(53)]);
                setLimites({ liviano, pesado });
            };

            Promise.all([obtenerCasoImplicado(), obtenerParametros(), obtenerObsFallback(), obtenerLimites()]).finally(() => setDataReady(true));
        }
    }, [listaProvisionesVigentes, amparosCia]);

    useEffect(() => {
        const total = coberturas.reduce((acc, c) => acc + Number(validateMontoMoneda(c.montoPretencion, 'reset_format')), 0);
        setStateMontoTotal(validateMontoMoneda(total, 'format'));
    }, [coberturas]);

    useEffect(() => {
        setCoberturas(prev => prev.map(c => ({ ...c, montoPretencion: validateMontoMoneda(validateMontoMoneda(c.montoPretencion, 'reset_format'), 'format') })));
    }, [stateMoneda]);

    const handleSelect = (k) => setKey(k === key ? "" : k);

    const handleChangeCoberturaMonto = (id, value) => {
        setCoberturas(prev => prev.map(c => (c.id === id ? { ...c, montoPretencion: value } : c)));
    };

    const handleFocusBlurCobertura = (action, id, value) => {
        setCoberturas(prev => prev.map(c => c.id === id ? { ...c, montoPretencion: validateMontoMoneda(value, action === 'focus' ? 'reset_format' : 'format') } : c));
    };

    const handleChangeObsResponsable = (id, value) => {
        setCoberturas(prev => prev.map(c => c.id === id ? { ...c, obsResponsable: value } : c));
    };

    const handleVerObsCia = (obs) => {
        setObsCiaModalContent(obs);
        setShowObsCiaModal(true);
    };

    const validateMontoMoneda = (value, action) => {
        let monto = 0;
        if (action === 'format') monto = formatoMonto(value);
        else monto = Number(stateMoneda) === 30001 ? resetFormatoMontoSinPunto(value) : resetFormatoMonto(value);
        return monto;
    };

    // Determina si el botón Actualizar debe estar habilitado (solo aplica para PEC)
    const visarHabilitado = dataReady && (!isPEC || !tieneInformeAnterior ||
        coberturas.some(c => Number(validateMontoMoneda(c.montoPretencion, 'reset_format')) !== (initialMontos[c.id] || 0)) ||
        String(stateResponsabilidadAsegurado) !== String(initialRespAseg));

    const updateProvisiones = async () => {
        setShowConfirm(false);
        setLoading(true);
        const response = action === "button" ? await actualizarProvisiones(dataSubmit) : await actualizarIndemnizacion(dataSubmit);
        setLoading(false);
        setResponseData(response.respuestaActProvisiones);
        setShowToast(true);
    };

    const handleCloseToast = () => {
        setShowToast(false);
        if (responseData?.code === 1) {
            if (fileRef.current) fileRef.current.value = "";
            archivoSubidoRef.current = { file: null, s3Bucket: null, s3Key: null };
            handleClose();
        }
    };

    const handleFileChange = (e) => {
        const file = e.currentTarget.files[0];
        if (!file) return;

        if (esArchivoGrande(file, limites.liviano)) {
            setPendingFile(file);
            setShowConfirmGrande(true);
        } else {
            formik.setFieldValue("file", file);
        }
    };

    const handleCancelArchivoGrande = () => {
        setPendingFile(null);
        if (fileRef.current) fileRef.current.value = "";
        setShowConfirmGrande(false);
    };

    const handleConfirmArchivoGrande = () => {
        formik.setFieldValue("file", pendingFile);
        setShowConfirmGrande(false);
    };

    const handleVerPretensionesImplicado = () => {
        if (llaves) {
            setLoading(true);
            setShowModalProvisionesImplicado(true);
            setShowImplicadosHistorial(false);

            let query = Buffer.from(JSON.stringify({ idCaso: llaves['idCaso'], tipoMovimiento: action === "button" ? 261002 : 261003 })).toString('base64');
            dispatch(obtenerProvisionesImplicados(query)).then(() => setLoading(false));
        }
    };

    const handleVerHistorialPretensiones = () => {
        if (llaves) {
            setLoading(true);
            setShowImplicadosHistorial(true);
            setShowImplicados(false);

            let query = Buffer.from(JSON.stringify({ idCaso: llaves['idCaso'], idImplicado: llaves['idImplicado'], tipoMovimiento: action === "button" ? 261002 : 261003 })).toString('base64');
            dispatch(obtenerHistorialProvisiones(query)).then(() => setLoading(false));
        }
    };

    const formik = useFormik({
        initialValues: {
            codMonedaIngreso: "",
            fechaActualizacion: "",
            comentario: "",
            idInstanciaProvision: "",
            informe: "",
            responsabilidadAsegurado: "",
            amparoAfectado: ""
        },
        validationSchema: validationSchemasProvision(fechaActualizaPrevision, fechaSiniestro, limites.pesado),
        onSubmit: async (data) => {
            if (Number(coberturas.reduce((acc, c) => acc + Number(validateMontoMoneda(c.montoPretencion, 'reset_format')), 0)) > 0) {
                let dataResult = { ...data };
                dataResult.idCaso = llaves['idCaso'];
                dataResult.idImplicadoCaso = llaves['idImplicado'];
                dataResult.idOrganizacion = llaves['idOrgCaso'];
                dataResult.codMonedaLocal = 30001;
                dataResult.idUsuario = llaves['idUsuario'];
                dataResult.tipoMovimiento = action === "button" ? 261002 : 261003;
                dataResult.fechaActualizacion = data.fechaActualizacion ? data.fechaActualizacion.split('-').join('') : "";

                dataResult.coberturas = coberturas.map(c => ({
                    id: c.id,
                    montoPretension: Number(validateMontoMoneda(c.montoPretencion, 'reset_format')),
                    codigoAmparoPadre: c.codigoAmparoPadre,
                    codigoCobertura: c.codigoCobertura,
                    actualizaMonto: c.actualizaMonto || "N",
                    obsResponsable: isPEC ? (c.obsResponsable || null) : undefined,
                }));

                if (data.file) {
                    if (esArchivoGrande(data.file, limites.liviano)) {
                        try {
                            setLoading(true);
                            let archivoRef;
                            if (archivoSubidoRef.current.file === data.file) {
                                archivoRef = archivoSubidoRef.current;
                            } else {
                                archivoRef = await subirArchivoGrandeS3(data.file);
                                archivoSubidoRef.current = { file: data.file, ...archivoRef };
                            }
                            dataResult = { ...dataResult, "filename": data.file.name, "mimetype": data.file.type, "s3Bucket": archivoRef.s3Bucket, "s3Key": archivoRef.s3Key };
                            setLoading(false);
                            setDataSubmit(dataResult);
                            setShowConfirm(true);
                        } catch (err) {
                            setLoading(false);
                            setResponseData({ code: -1, object: null, message: err.message });
                            setShowToast(true);
                        }
                    } else {
                        const base64data = await getBase64(data.file);
                        const fileData = base64data.split(',')[1];
                        dataResult = { ...dataResult, "filename": data.file.name, "mimetype": data.file.type, "base64data": fileData };
                        setDataSubmit(dataResult);
                        setShowConfirm(true);
                    }
                } else {
                    setDataSubmit(dataResult);
                    setShowConfirm(true);
                }
            } else setShowModalTotal(true);
        }
    });

    // Info de encabezado de grilla PEC (estado/fecha/usuario del último informe)
    const infoGrillaPEC = isPEC && coberturas.length > 0 ? coberturas[0] : null;

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Card>
                {inprocess ?
                    <Card.Header style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        Historial {action === "button" ? "Provisiones" : "Valorizacines PEC"} Implicado - {implSeleccionado.NombreImplicado} ({implSeleccionado.IdImplicado} - {implSeleccionado.Patente})
                    </Card.Header> :
                    <Card.Header style={{ backgroundColor: '#4F517A', color: 'white' }}>
                        {action === "button" ? (cfg_form39?.cfg_form39['modalprovippta-title-modal']) : (cfg_form39?.cfg_form39['modalprovippta-title-modal-ppta'])} {involucrado.id}
                    </Card.Header>
                }

                {!inprocess &&
                    <Container>
                        <fieldset disabled={!dataReady} style={{ border: 'none', padding: 0, margin: 0 }}>
                        <Form onSubmit={formik.handleSubmit}>
                            <Container className='mb-4'>
                                <Row>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisioneslbl-rut'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {involucrado.rut && formato_rut(involucrado.rut)}
                                        </Form.Text>
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisioneslbl-nombre'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {involucrado.nombre && involucrado.nombre}
                                        </Form.Text>
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisioneslbl-tipoinvol'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {involucrado.tipo && involucrado.tipo}
                                        </Form.Text>
                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisioneslbl-patente'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {involucrado.patente && involucrado.patente}
                                        </Form.Text>
                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisiones-lbl-impllesio'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mb-3'>
                                            {involucrado.lesionado && involucrado.lesionado}
                                        </Form.Text>
                                    </Col>
                                </Row>
                            </Container>

                            <Container className='mb-4'>
                                <hr style={{ borderTop: '3px solid #04005D' }}></hr>
                                <Row className='form'>
                                    <Col md='2'>
                                        <Form.Label className="is_required">
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisionescmb-moneda'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Select
                                            className='mt-2'
                                            name='codMonedaIngreso'
                                            onChange={(e) => { formik.handleChange(e); setStateMoneda(e.target.value) }}
                                            value={formik.values.codMonedaIngreso = stateMoneda}>
                                            <option value=''>Seleccione...</option>
                                            {comboMonedas?.filter(m => m.id === Number(codMonedaLocal) || m.id === Number(codMonedaConsolida))
                                                .map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                                        </Form.Select>
                                        {formik.errors.codMonedaIngreso && formik.touched.codMonedaIngreso &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.codMonedaIngreso}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='2'>
                                        <Form.Label className="is_required">
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisionescmb-fechaact'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            className='mt-2'
                                            type="date"
                                            name='fechaActualizacion'
                                            min={parametro && minDate(parametro)}
                                            max={today()}
                                            value={formik.values.fechaActualizacion = stateFechaActualizacion}
                                            onChange={e => { formik.handleChange(e); setStateFechaActualizacion(e.target.value) }}
                                        />
                                        {formik.errors.fechaActualizacion && formik.touched.fechaActualizacion &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.fechaActualizacion}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label className="is_required">
                                            {action === "button" ? (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-input-instanciaprovi'] : '') : (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-cmb-instancia-ppta'] : '')}
                                        </Form.Label>
                                        <br />
                                        <Form.Select
                                            className='mt-2'
                                            name='idInstanciaProvision'
                                            onChange={(e) => { formik.handleChange(e); setStateInstanciaProvision(e.target.value) }}
                                            value={formik.values.idInstanciaProvision = stateInstanciaProvision}>

                                            <option value={''}>Seleccione...</option>
                                            {comboInstanciasPrevisiones && comboInstanciasPrevisiones.comboInstanciasPretensiones?.map((c) => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.idInstanciaProvision && formik.touched.idInstanciaProvision &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.idInstanciaProvision}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='5'>
                                        <Form.Label className='mt-2'>
                                            {action === "button" ? (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-input-preinforme'] : '') : (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-input-preinforme-ppta'] : '')}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            className='mt-2'
                                            name='file'
                                            type="file"
                                            ref={fileRef}
                                            onChange={handleFileChange}
                                            onBlur={formik.handleBlur}>
                                        </Form.Control>
                                        {formik.errors.file && formik.touched.file &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.file}
                                            </Form.Text>
                                        }
                                    </Col>
                                </Row>
                                <Row className='form mt-3'>
                                    <Col md='6'>
                                        <Form.Label className="is_required">
                                            {action === "button" ? (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-input-comentario'] : '') : (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-input-comentario-ppta'] : '')}
                                        </Form.Label>
                                        <br />
                                        <Form.Control
                                            className='mt-2'
                                            name='comentario'
                                            value={formik.values.comentario = stateComentario}
                                            onChange={e => { formik.handleChange(e); setStateComentario(e.target.value) }}
                                        />
                                        {formik.errors.comentario && formik.touched.comentario &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.comentario}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='6'>
                                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modaalprovisiones-lbl-comenvisado'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mt-2'>
                                            {comentarioVisado}
                                        </Form.Text>
                                    </Col>
                                </Row>
                                <hr style={{ color: '#04005D', height: '4px', marginTop: '20px', marginBottom: '5' }}></hr>
                                <Row>
                                    <Col md='3'>
                                        <Form.Label style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-lbl-resp-actual'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Text className='mt-2'>
                                            {responsabilidadAseguradoActual}
                                        </Form.Text>
                                    </Col>
                                    <Col md='3'>
                                        <Form.Label className="is_required" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-cmb-reasp-asegurado'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Select
                                            className='mt-2'
                                            name='responsabilidadAsegurado'
                                            onChange={(e) => { formik.handleChange(e); setStateResponsabilidadAsegurado(e.target.value) }}
                                            value={formik.values.responsabilidadAsegurado = stateResponsabilidadAsegurado}>

                                            <option value={''}>Seleccione...</option>
                                            {comboResponsabilidadAsegurado && comboResponsabilidadAsegurado.comboResponsabilidadAsegurado?.map((c) => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.responsabilidadAsegurado && formik.touched.responsabilidadAsegurado &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.responsabilidadAsegurado}
                                            </Form.Text>
                                        }
                                    </Col>
                                    <Col md='4'>
                                        <Form.Label className="is_required" style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-cmb-amparo-afectado'] : ''}
                                        </Form.Label>
                                        <br />
                                        <Form.Select
                                            className='mt-2'
                                            name='amparoAfectado'
                                            onChange={(e) => { formik.handleChange(e); setStateAmparoAfectado(e.target.value) }}
                                            value={formik.values.amparoAfectado = stateAmparoAfectado}>

                                            <option value={''}>Seleccione...</option>
                                            {amparosAfectados && amparosAfectados?.map((c) => (
                                                <option key={c.id} value={c.id}>{c.nombre}</option>
                                            ))}
                                        </Form.Select>
                                        {formik.errors.amparoAfectado && formik.touched.amparoAfectado &&
                                            <Form.Text variant='danger' style={{ color: 'red' }}>
                                                {formik.errors.amparoAfectado}
                                            </Form.Text>
                                        }
                                    </Col>
                                </Row>
                            </Container>
                            <Container>
                                <div className="container_table">
                                    <div className="container_table_header d-flex align-items-center">
                                        <span className="me-3">
                                            {action === "button" ? (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-title-grilla-vig'] : '') : (cfg_form39 ? cfg_form39.cfg_form39['modalprovippta-title-grilla-ppta-vig'] : '')}
                                        </span>
                                        {isPEC && infoGrillaPEC && (
                                            <>
                                                <span className="me-3" style={{ opacity: 0.4 }}>|</span>
                                                <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#d4d0f0' }}>
                                                    {infoGrillaPEC.glosaEstado && <span className="me-3"><span style={{ opacity: 0.7 }}>Estado:</span> {infoGrillaPEC.glosaEstado}</span>}
                                                    {infoGrillaPEC.fechaRegistroFmt && <span className="me-3"><span style={{ opacity: 0.7 }}>Fecha Registro:</span> {infoGrillaPEC.fechaRegistroFmt}</span>}
                                                    {infoGrillaPEC.usuario && <span><span style={{ opacity: 0.7 }}>Usuario:</span> {infoGrillaPEC.usuario}</span>}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                    <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '30%' }}>{cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-grilla-cobertura'] : ''}</th>
                                                <th style={{ whiteSpace: 'nowrap' }}>{cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-grilla-monto'] : ''} {monedaSelected ? `(${monedaSelected})` : ""}</th>
                                                {isPEC && <th>Observación Abogado</th>}
                                                {isPEC && <th style={{ width: '50px', textAlign: 'center' }}>Obs. CIA</th>}
                                                {!isPEC && <th>{cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-grilla-estado'] : ''}</th>}
                                                {!isPEC && <th>{cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-grilla-fecharegistro'] : ''}</th>}
                                                {!isPEC && <th>{cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-grilla-usuario'] : ''}</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {coberturas.map(c => (
                                                <tr key={c.id}>
                                                    <td>{c.nombre}</td>
                                                    <td style={{ width: '130px' }}>
                                                        {c.actualizaMonto === 'S' ? (
                                                            <Form.Control
                                                                value={formik.values[`cobertura${c.id}`] = c.montoPretencion}
                                                                readOnly={!stateMoneda}
                                                                onChange={e => { formik.handleChange(e); handleChangeCoberturaMonto(c.id, e.target.value) }}
                                                                onBlur={e => handleFocusBlurCobertura('blur', c.id, e.target.value)}
                                                                onFocus={e => handleFocusBlurCobertura('focus', c.id, e.target.value)}
                                                                onKeyPress={e => moneyPunto(e, Number(stateMoneda) !== 30001)}
                                                                style={{ width: '120px' }}
                                                            />
                                                        ) : (
                                                            formatoMonto(c.montoCobertura, false)
                                                        )}
                                                    </td>
                                                    {isPEC && (
                                                        <td>
                                                            <Form.Control
                                                                as="textarea"
                                                                rows={1}
                                                                value={c.obsResponsable}
                                                                onChange={e => handleChangeObsResponsable(c.id, e.target.value)}
                                                                maxLength={500}
                                                                style={{ resize: 'none', width: '100%', fontSize: '15px' }}
                                                            />
                                                        </td>
                                                    )}
                                                    {isPEC && (
                                                        <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                                            {c.obsAnalistaCIA ? (
                                                                <MdComment
                                                                    size={22}
                                                                    style={{ color: '#4F517A', cursor: 'pointer' }}
                                                                    title="Ver observación CIA"
                                                                    onClick={() => handleVerObsCia(c.obsAnalistaCIA)}
                                                                />
                                                            ) : (
                                                                <MdComment size={22} style={{ color: '#ccc' }} title="Sin observación CIA" />
                                                            )}
                                                        </td>
                                                    )}
                                                    {!isPEC && <td>{c.glosaEstado}</td>}
                                                    {!isPEC && <td>{c.fechaRegistroFmt}</td>}
                                                    {!isPEC && <td>{c.usuario}</td>}
                                                </tr>
                                            ))}
                                            <tr>
                                                <td><strong>Total</strong></td>
                                                <td colSpan={isPEC ? 3 : 4}><strong>{stateMontoTotal} {monedaSelected}</strong></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </Container>
                             {showToast && <Mensajes showToast={showToast} handleCloseToast={handleCloseToast} delay={5000} responseData={responseData} />}
                            <Container>
                                <Row>
                                    <Col className='d-flex align-items-end justify-content-end m-2 p-0'>
                                        <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-btn-volver'] : ''}
                                        </Button>
                                        <Button className='m-2 w-auto' variant='verGrilla' onClick={handleVerPretensionesImplicado}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-btn-implicados'] : ''}
                                        </Button>
                                        <Button className='m-2' variant='verGrilla' onClick={handleVerHistorialPretensiones}>
                                            {cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-btn-historial'] : ''}
                                        </Button>
                                        <Button type="submit" className='m-2' variant='actualizar' disabled={!visarHabilitado || loading}>
                                            {loading && <Spinner as="span" animation="border" size="sm" className="me-2" />}
                                            {cfg_form39 ? cfg_form39.cfg_form39['modalprovisiones-btn-actualziar'] : ''}
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                        </fieldset>
                    </Container>
                }
            </Card>

            <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
                <Card>
                    <Card.Header style={{ backgroundColor: '#e8761a', color: 'white' }}>Confirmación</Card.Header>
                    <Card.Body>
                        {action === "button" ? "Confirma nuevas provisiones al implicado del caso en referencia?" : "Confirma valorización PEC al implicado del caso en referencia?"}
                    </Card.Body>
                    <Card.Footer className='d-flex justify-content-center'>
                        <Button variant='outline-info' onClick={() => setShowConfirm(false)}>No</Button>
                        <Button variant='danger' onClick={updateProvisiones}>Si</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showModalTotal} onHide={() => setShowModalTotal(false)}>
                <Card>
                    <Card.Header style={{ backgroundColor: '#e8761a', color: 'white' }}>Información</Card.Header>
                    <Card.Body>
                        {action === "button" ? "Monto total Provisión debe ser mayor a 0." : "Monto total Propuesta Indemnización debe ser mayor a 0."}
                    </Card.Body>
                    <Card.Footer className='d-flex justify-content-center'>
                        <Button variant='outline-info' onClick={() => setShowModalTotal(false)}>Cerrar</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showConfirmGrande} onHide={handleCancelArchivoGrande}>
                <Card>
                    <Card.Header style={{ backgroundColor: '#e8761a', color: 'white' }}>Confirmación</Card.Header>
                    <Card.Body>
                        {`El archivo seleccionado supera los ${limites.liviano / 1000000}MB, por lo que la carga puede demorar más de lo habitual. ¿Desea continuar?`}
                    </Card.Body>
                    <Card.Footer className='d-flex justify-content-center'>
                        <Button variant='outline-info' onClick={handleCancelArchivoGrande}>No</Button>
                        <Button variant='danger' onClick={handleConfirmArchivoGrande}>Sí</Button>
                    </Card.Footer>
                </Card>
            </Modal>

            <Modal show={showObsCiaModal} onHide={() => setShowObsCiaModal(false)} size='md' centered>
                <Modal.Header style={{ backgroundColor: '#4F517A', color: 'white' }} closeButton>
                    <Modal.Title>Observación Analista CIA</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Text style={{ whiteSpace: 'pre-wrap', fontSize: '14px' }}>{obsCiaModalContent}</Form.Text>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='outline-secondary' onClick={() => setShowObsCiaModal(false)}>Cerrar</Button>
                </Modal.Footer>
            </Modal>

            {showModalProvisionesImplicado &&
                <GrillaPrevisionesImplicados
                    action={action}
                    setShowModalProvisionesImplicado={setShowModalProvisionesImplicado}
                    showModalProvisionesImplicado={showModalProvisionesImplicado}
                />
            }
            <style type='text/css'>
                {`
                    .btn-verGrilla {
                        background-color: #55B2CE;
                        color: #FFFFFF;
                        width: 168px;
                        }
                    .btn-verGrilla:hover{
                            background-color: #87c9dc;
                            color: #FFFFFF;
                    }
                    .is_required:after {
                        content: "(*)";
                        margin-left: 2px;
                        color: #000;
                        font-weight: 500;
                        font-size: 12pt;
                    }
                    .container_table span {
                        color: white;
                    }
                    .container_table_header {
                        padding: 10px 20px;
                        background-color: #716e9e;
                        border-top-left-radius: 5px;
                        border-top-right-radius: 5px;
                    }
                    .form {
                        margin-top: 5px;
                    }

                    .form label {
                        font-weight: bold;
                        font-size: 14px;
                        margin-bottom: 0;
                        margin-top: 5px
                    }
                `}
            </style>
        </Fragment>
    );
};

export default Previsiones;
